var _defs, _path, _clipPath, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRinse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1031.7838,
    height: 1014.4614,
    viewBox: "0 0 1031.7838 1014.4614",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    id: "svg1861",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rinse",
    transform: "matrix(0.829192,0,0,1.09268,-276.88263,-1697.2009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1750"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 955.502,613.628 c 1.668,-96.032 80.148,-173.478 176.568,-173.478 96.42,0 174.9,77.446 176.57,173.478 h 0.03 V 1440.76 H 1173.64 V 616.746 c 0,-22.941 -18.63,-41.566 -41.57,-41.566 -22.94,0 -41.57,18.625 -41.57,41.566 V 768.191 H 955.475 V 613.628 Z",
    id: "path1725"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 955.502,613.628 c 1.668,-96.032 80.148,-173.478 176.568,-173.478 96.42,0 174.9,77.446 176.57,173.478 h 0.03 V 1440.76 H 1173.64 V 616.746 c 0,-22.941 -18.63,-41.566 -41.57,-41.566 -22.94,0 -41.57,18.625 -41.57,41.566 V 768.191 H 955.475 V 613.628 Z",
    id: "path1727"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)",
    id: "g1748"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.585555,0,0,0.771625,725.255,-766.763)",
    id: "g1732"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 694.752,1564.12 c 166.45,0 301.587,102.55 301.587,228.86 0,126.31 -135.137,228.86 -301.587,228.86 -166.45,0 -301.587,-102.55 -301.587,-228.86 0,-126.31 135.137,-228.86 301.587,-228.86 z m 0,174.99 c 39.178,0 70.986,24.14 70.986,53.87 0,29.73 -31.808,53.87 -70.986,53.87 -39.178,0 -70.986,-24.14 -70.986,-53.87 0,-29.73 31.808,-53.87 70.986,-53.87 z",
    id: "path1730"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.629734,0,0,0.706176,-375.231,-1395.84)",
    id: "g1736"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2113.1201,
    y: 2849.98,
    width: 560.85797,
    height: 491.36801,
    id: "rect1734"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 1176.62,440.15 c 0,0 22.29,45.857 -21.32,72.996 -43.62,27.138 -112.13,4.805 -112.13,69.764 v 200.654 l -150.539,29.608 49.431,-322.319 c 0,0 194.818,-101.405 234.558,-50.703 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1191.16,449.176 c 0,0 -195.025,-53.871 -234.607,155.047 -0.812,122.655 -1.078,162.864 -1.078,162.864",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "24.22px"
    },
    id: "path1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 955.475,767.087 H 1091.73",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "24.22px"
    },
    id: "path1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1132.07,574.969 c 0,0 51.19,-10.579 87.89,44.594 36.7,55.173 18.85,821.197 18.85,821.197 h -56.49 c 0,0 0,-760.96 -50.25,-865.791",
    style: {
      fill: "#ffffff"
    },
    id: "path1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1120.89,576.702 c 0,0 52.75,-14.133 52.75,51.13 v 812.928 h 135.03",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "24.22px"
    },
    id: "path1746"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19931,0.0962388,-0.12682,0.910105,-1840.64,-1103.87)",
    id: "g1754"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2875.28,2941.22 c 0,0 107.96,622.61 -212.02,518.86 -319.97,-103.75 -399.09,-53.77 -480.85,31.7 123.45,-20.86 286.53,-15.67 386.9,96.85 289.18,185.43 478.15,-65.94 305.97,-647.41 z",
    id: "path1752"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19815,0.104219,-0.137336,0.909226,-1768.99,-1110.81)",
    id: "g1758"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2535.75,3125.16 c 0,0 -97.82,186.31 90.57,273.12 42.35,27.63 81.09,64.01 81.09,64.01 0,0 -175.82,-68.97 -262.62,-68.97 -311.97,-74.08 -93.46,-340.12 9.26,-322.9 -31.03,135.02 7.87,149.58 11.34,167.61 3.47,18.03 -35.1,-49.81 70.36,-112.87 z",
    id: "path1756"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-2232.95,-871.166)",
    id: "g1762"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2283.47,3352.46 c 0,0 -109.51,-32.23 -108.88,13.91 0.63,46.14 85.03,-33.5 108.88,-13.91 z",
    id: "path1760"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17819,0,0,0.953332,-2140.43,-954.295)",
    id: "g1766"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2850.01,2941.22 c 0,0 -17.11,86.13 -76.05,112.47 31.44,40.72 82.15,-35.13 76.05,-112.47 z",
    id: "path1764"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-2232.95,-854.391)",
    id: "g1770"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2891.28,2961.05 c 0,0 -8.16,114.98 63.19,93.35 17.11,-5.19 25.05,-35.22 -3.47,-35.22 -32.69,0 -41.6,-27.64 -59.72,-58.13 z",
    id: "path1768"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1774"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1046.17,820.021 c 0,0 7.52,48.622 24.72,61.943 38.3,25.199 63.28,3.072 39.52,-8.807 -23.66,1.485 -41.19,-2.666 -64.24,-53.136 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1772"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1778"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1068.96,487.592 c 0,0 34.44,-1.694 25.12,12.139 -9.31,13.834 -40.08,21.738 -45.17,27.102 -5.08,5.364 -21.45,22.646 -21.45,22.646 l -24,1.633 c 0,0 38.96,-58.721 65.5,-63.52 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "6.06px"
    },
    id: "path1776"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1782"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 955.47498,
    y: 692.24799,
    width: 133.44299,
    height: 41.905998,
    id: "rect1780"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1786"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1260.18,517.861 c 0,0 41.73,23 35,174.387 -6.73,151.386 -4.04,730.242 -4.04,730.242",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "6.06px"
    },
    id: "path1784"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1790"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1132.07,566.939 c 0,0 -46.75,-3.447 -47.44,41.354 -0.69,44.8 -2.25,146.126 -2.25,146.126 l -57.72,0.682",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "6.06px"
    },
    id: "path1788"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-3.72385,1153.66)",
    id: "g1794"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1202.96,
    cy: 778.23602,
    rx: 6.1760001,
    ry: 7.9400001,
    id: "ellipse1792"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523532,0,0,0.915179,813.526,1144.9)",
    id: "g1798"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1202.96,
    y: 799.38202,
    width: 14.226,
    height: 623.104,
    id: "rect1796"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523532,0,0,0.293422,829.814,2045.42)",
    id: "g1802"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1202.96,
    y: 799.38202,
    width: 14.226,
    height: 623.104,
    id: "rect1800"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1806"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1011.69,815.32 c 1.45,1.932 -25.901,93.143 -69.935,109.19 17.281,7.216 29.977,-8.247 34.545,-13.037 22.433,-23.531 35.17,-86.516 35.39,-96.153 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1804"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1810"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 959.81,934.89 c 0,0 40.51,-8.493 50.62,-93.041",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "1.67px"
    },
    id: "path1808"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1814"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1033.1,864.948 c 0,0 36.33,691.252 -196.916,463.122 84.315,2.24 184.436,6.97 196.916,-463.122 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1812"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1818"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 329.716,1200.16 c -0.992,-7.95 5.416,-33.83 81.037,-17.4 -52.174,8.14 -62.905,9.26 -81.037,17.4 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1816"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.927788,0,0,0.87965,119.558,1150.73)",
    id: "g1822"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 446.54,1109.74 c 0,0 14.666,-89.73 127.834,-65.4 -8.469,-23.15 -97.488,-8.04 89.306,-145.269 -118.16,3.961 -257.39,108.469 -217.14,210.669 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1820"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1826"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 619.197,907.249 c 0,0 -44.23,100.551 -11.853,153.451",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5
    },
    id: "path1824"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1830"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 686.726,976.233 c 0,0 -79.725,80.517 -35.007,164.077 -21.343,-17.5 -83.571,-101.29 35.007,-164.077 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1828"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1834"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 695.051,970.535 c 0,0 -116.215,172.485 62.206,282.015 36.7,29.36 59.285,55.33 59.285,55.33",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "2.5px"
    },
    id: "path1832"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1838"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 454.097,1115.85 c 0,0 25.762,69.86 141.397,101.18 102.379,23.19 157.325,61.8 205.506,82.39",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "3.33px"
    },
    id: "path1836"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1842"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1051,871.299 c 0,0 14.39,52.28 63.27,29.754",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "1.67px"
    },
    id: "path1840"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1846"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1035.15,871.299 c 12.61,92.056 86.91,828.061 -372.02,549.871",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "3.75px"
    },
    id: "path1844"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1850"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 663.13,1421.48 c 0,0 -96.26,-165.48 -361.926,-143.34",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "3.33px"
    },
    id: "path1848"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1854"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 331.995,1205.88 c 0,0 -2.012,19.12 50.297,-10.06",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "1.67px"
    },
    id: "path1852"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-4.48348,1111.3)",
    id: "g1858"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 829.264,1325.46 c -145.371,-35.96 -387.634,-193.7 -532.112,-51.17 187.891,-45.31 313.351,11.06 365.978,86.98 -5.117,-60.02 -55.828,-107.35 166.134,-35.81 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1856"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRinse);
export default __webpack_public_path__ + "static/media/rinse.951a7ac99e7941a6a2ecc37bfab5bb1b.svg";
export { ForwardRef as ReactComponent };